/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `VisibilityOffIconProps` interface defines the properties for the VisibilityOffIcon component.
 */
interface VisibilityOffIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "visibility_off" — outlined, weight 300.
 * Eye-off icon for hiding password fields.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const VisibilityOffIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'VisibilityOffIcon',
    width
}: VisibilityOffIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m637-425-62-62q4-38-23-65.5T487-576l-62-62q13-5 27-7.5t28-2.5q75 0 127.5 52.5T660-468q0 14-2.5 28t-7.5 27l-13-12ZM753-311l-58-58q38-29 67.5-63.5T808-500q-50-121-144.5-180.5T480-740q-33 0-65 6t-63 18l-62-62q41-17 84-25.5t86-8.5q146 0 265.5 81.5T920-500q-26 64-67 117t-100 97v-25ZM792-56 624-222q-35 11-71 16.5t-73 5.5q-146 0-266-81.5T40-500q22-57 58-103.5T182-696L56-822l42-43 737 737-43 43v-14ZM222-654q-29 26-53 57t-41 65q50 121 144.5 180.5T480-292q25 0 49-3.5t47-9.5L503-378q-8 3-16.5 4.5T470-372q-75 0-127.5-52.5T290-552q0-8 1.5-16.5T296-585l-74-69ZM541-531Zm-131 65Z" />
    </svg>
);

VisibilityOffIcon.displayName = 'VisibilityOffIcon';